import Head from 'next/head'
import linkResolver from '~/lib/link-resolver'
import { PRISMIC_TYPES } from '~/lib/prismic-types'

import { useIsMountedState } from '@unlikelystudio/react-hooks'

import LoadingPage from '~/components/Abstracts/LoadingPage'

import useAuthentication from '~/hooks/account/useAuthentication'
import useLocale from '~/hooks/useLocale'

export default function withAuthentication(WrappedComponent) {
  const HOC = (pageProps) => {
    const locale = useLocale()

    const { isSuccess, data, isIdle } = useAuthentication(
      linkResolver({ type: PRISMIC_TYPES.LOGIN }, locale),
      null,
    )

    const isMounted = useIsMountedState()

    return (
      <>
        <Head>
          <meta key="robots" name="robots" content="noindex,nofollow" />
        </Head>

        {(isIdle && !isSuccess) || data === null || !isMounted ? (
          <LoadingPage />
        ) : (
          <WrappedComponent {...pageProps} />
        )}
      </>
    )
  }

  return HOC
}
